export default {
  title: 'User permissions',
  confirmationModal: {
    title: 'Warning',
    body: 'By editing the default permissions for a user group you can adversly affect the ability for a login to use SchemeServe.\n\nPlease only edit the default group permissions if you are comfortable with its functionality.\nBy creating customised user permissions this login will not automatically receive access to new functionality.',
    checkboxMessage: 'I confirm I understand',
  },
  // tableHeaders: {
  //   permissions: 'Permissions',
  //   selectAll: 'Select all',
  //   create: 'Create',
  //   read: 'Read',
  //   update: 'Update',
  //   delete: 'Delete',
  // },
};
